import React from 'react';
import { LayoutSize } from '@bingads-webui-fluent-component/layout-size';

interface MenuContextProps {
  layoutSize: LayoutSize;
  singleComponentModeKey: string | undefined;
  dynamicallyPinedItemKey: string | undefined;
  updatePinedItemKey: (key: string | undefined) => void;
  updateMode: (key: string | undefined) => void;
}

export const MenuContext = React.createContext({ } as MenuContextProps);
